import axios from 'axios';

import ShippingAddress from '../models/SFModels/ShippingAddress';

const API_URL =
  process.env.REACT_APP_ENV === 'local'
    ? `${process.env.REACT_APP_API_LOCAL}/salesforce/shipping-address`
    : process.env.REACT_APP_ENV === 'production'
      ? `${process.env.REACT_APP_API_PRODUCTION}/salesforce/shipping-address`
      : `${process.env.REACT_APP_API_STAGING}/salesforce/shipping-address`;

const shippingAddressApi = {
  fetchShippingAddress(params) {
    return axios.get(`${API_URL}${params}`).then(response => {
      const { id, street, city, zipcode, country } = response.data;
      return new ShippingAddress(id, street, city, zipcode, country);
    });
  },

  updateShippingAddress(params, shippingAddressUpdated) {
    return axios
      .put(`${API_URL}?accountId=${params}`, shippingAddressUpdated, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(response => {
        return response.data;
      });
  },
};

export default shippingAddressApi;



// WEBPACK FOOTER //
// ./src/api/shippingAddress.js